import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.jsx'
import { AuthProvider } from './auth/AuthProvider.jsx'
import { initSyncManager } from './data/syncManager.js'
import AnalyticsTracker from './components/AnalyticsTracker.jsx'
import './utils/cryptoPolyfill.js'
import './index.css'

// Criar instância do QueryClient para React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutos
      refetchOnWindowFocus: false,
    },
  },
})

// Registrar Service Worker (mantém SW existente para push funcionar)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js')
    .then(reg => {
      window.__swRegistration = reg
      console.log('[SW] Registrado:', reg.scope)
    })
    .catch(err => console.warn('[SW] Falha ao registrar:', err))
}

// Limpar URLs malformadas se existirem
if (window.location.pathname.includes('~and~') || 
    window.location.search.includes('~and~') || 
    window.location.hash.includes('~and~')) {
  
  // Limpar todos os caches
  if ('caches' in window) {
    caches.keys().then(function(names) {
      names.forEach(function(name) {
        caches.delete(name);
      });
    });
  }
  
  // REMOVIDO: Não limpar storages automaticamente
  // if (typeof localStorage !== 'undefined') localStorage.clear();
  // if (typeof sessionStorage !== 'undefined') sessionStorage.clear();
  
  // Redirecionar para raiz limpa
  window.location.replace('./');
}

// Capturar prompt de instalação PWA
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault()
  window.deferredPrompt = e
})

// MODO ONLINE COM SUPABASE
// Inicializar sincronização com Supabase
initSyncManager()

ReactDOM.createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <BrowserRouter>
        <AnalyticsTracker />
        <App />
      </BrowserRouter>
    </AuthProvider>
  </QueryClientProvider>
)
